module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section05_02_american-village-fc38355c8d441e2b4b00881c230cb58f.jpg";